<template>
  <div class="py-4 sm:grid sm:grid-cols-4 sm:gap-4 sm:py-5">
    <dt class="text-sm font-medium text-gray-500 flex flex-col justify-between">{{ title }}</dt>
    <div class="mt-1 sm:mt-0 col-span-3">
      <Toggle :value="value" @input="inp => $emit('input', inp)"/>

      <transition
        @enter="enter"
        @leave="leave"
      >
        <div v-if="value">
          <slot></slot>
        </div>
      </transition>

    </div>
  </div>
</template>

<script>

import Toggle from "./../Inputs/Toggle"

import transitionFunctionConstructor from "@/mixins/transitionFunctionConstructor"

export default {
  mixins: [
    transitionFunctionConstructor(),
  ],
  components: {
    Toggle,
  },
  props: {
    title: String,
    value: [String, Boolean],
  },
}

</script>
